import styled from "styled-components"

import { minWidth } from "utils"

import CloudinaryImage from "components/cloudinary-image"
import MoreArticles from "components/category/more-articles"

export const Container = styled.div`
  padding: 4rem 2rem 0;
  display: flex;
  align-items: center;
  flex-direction: column-reverse;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #222;

  ${minWidth.tablet`
    padding: 4rem 4rem 1rem;
    justify-content: center;
    align-items: flex-start;
    flex-direction: row;
  `}
`

export const ContainerLeft = styled.div`
  padding: 4rem 0 4rem;
  width: 100%;
  margin: 0;

  ${minWidth.tablet`
    margin-left: calc(1/12 * 100%);
    padding-top: 4rem;
    padding-right: 2rem;
  `}

  ${minWidth.desktop`
    margin: 0 calc(1/12 * 100%);
  `}
`

export const Name = styled.h1`
  font-size: 2.5em;
  font-weight: 500;
  line-height: 4.4rem;

  ${minWidth.tablet`
    margin-bottom: 1rem;
  `};

  ${minWidth.desktop`
    margin-bottom: 1.5rem;
    font-size: 4em;
    line-height: 1.06;
  `};
`

export const Title = styled.h3`
  margin-bottom: 1.5rem;
  font-size: 0.75em;
  font-weight: 300;
  color: #767676;

  ${minWidth.tablet`
    font-size: 0.95em;
  `};
`

export const Biography = styled.div`
  margin-top: 2rem;
  margin-bottom: 3rem;
  font-size: 1em;
  line-height: 2.6rem;

  ${minWidth.desktop`
    margin-top: 3rem;
    margin-bottom: 1rem;
  `}

  a {
    text-decoration: underline;
    color: #b54b09;
  }
`

export const Interview = styled.div`
  ${minWidth.tablet`
    width: calc(5/7 * 100%);
  `}

  ${minWidth.desktop`
    width: calc(4/5 * 100%);
  `}
`
export const InterviewTitle = styled.h2`
  width: 100%;
  margin-bottom: 4rem;
  font-family: Abril, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.66667em;
  line-height: 1.3;
  text-align: center;

  ${minWidth.tablet`
    font-size: 2.5em;
    text-align: left;
  `}
`

export const InterviewText = styled.div`
  line-height: 1.63;

  h2 {
    margin-bottom: 1rem;
    font-size: 1em;
    font-weight: 500;

    ${minWidth.tablet`
      font-size: 1em;
    `}
  }

  p {
    margin-bottom: 1.63em;
    font-size: 1em;
  }
`

export const SocialMediaText = styled.h2`
  width: 100%;
  margin-bottom: 2.6rem;
  padding-top: 1rem;
  border-top: 0.1rem solid #f1f1f1;
  font-size: 0.75em;
  line-height: 1;
  letter-spacing: 2px;
  text-align: center;
  text-transform: uppercase;
  color: #767676;

  ${minWidth.tablet`
    margin-bottom: 2.25rem;
    border: 0;
    text-align: left;
  `}
`

export const SocialMediaContainer = styled.div`
  margin-bottom: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;

  a:not(:first-child) {
    padding-left: 2.55rem;
  }

  ${minWidth.tablet`
    justify-content: flex-start;
  `}

  ${minWidth.desktop`
    margin-bottom: 8rem;
  `}
`

export const ContainerRight = styled.div`
  height: 100%;

  ${minWidth.tablet`
    position: sticky;
    top: 12rem;
  `}
`
export const FixedContainer = styled.div`
  position: relative;
  min-width: 18.8rem;
  min-height: 18.8rem;
  border: 0.6rem solid rgba(118, 118, 118, 0.25);
  border-radius: 50%;

  ${minWidth.tablet`
    min-width: 22rem;
    min-height: 22rem;
    margin: 4rem 0 3.5rem;
  `};

  ${minWidth.desktop`
    min-width: 36rem;
    min-height: 36rem;
  `}
`

export const AuthorImage = styled(CloudinaryImage)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #ffc280;
  transition: opacity 0.5s ease;
`

export const StyledMoreArticles = styled(MoreArticles)`
  ${minWidth.desktop`
    padding: 1rem 12rem 4rem 12rem;
  `}
`
